const NavigationLink = ({ children, href }: { children: React.ReactNode; href: string }) => {
  return (
    <a href={href} className='text-grey500 font-[MuseoSans900] uppercase tracking-[1.5px]'>
      {children}
    </a>
  );
};

export default NavigationLink;
